export default "__VITE_ASSET__DjpSz5YQ__"